export default __webpack_public_path__ + "static/media/org_address.881424fc.svg";